import {
  ESProfileSection,
  ESProfileSectionListItem,
  ESRoutes,
} from '@energy-stacks/shared';
import { useAppSelector } from '@energy-stacks/fleet/store';
import { IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useOidc } from '@axa-fr/react-oidc';
import { useGetUserQuery } from '@energy-stacks/fleet/feature-users-data';
import { IconNotebook } from '@tabler/icons-react';
import { IconExternalLink } from '@tabler/icons-react';
import { USER_MANUAL_URL } from './UserWelcomeDialog';

export const FleetProfileSection = () => {
  const { logout } = useOidc();
  const themeMode = useAppSelector((state) => state.theme.themeState);
  const sidebarOpened = useAppSelector((state) => state.sidebar.sidebarOpened);
  const { data: user } = useGetUserQuery();
  const [t] = useTranslation('users');
  const [tShared] = useTranslation('shared');

  return (
    <ESProfileSection
      userName={user?.displayName || ''}
      emailAddress={user?.emailAddress || ''}
      themeMode={themeMode}
      collapsed={!sidebarOpened}
    >
      <ESProfileSectionListItem
        listItemText={t('userManual')}
        testId="popupUserManualListItem"
        Icon={<IconNotebook stroke={1.5} size={20} />}
        EndIcon={<IconExternalLink stroke={1.5} size={20} />}
        href={USER_MANUAL_URL}
      />
      <ESProfileSectionListItem
        listItemText={tShared('logout')}
        testId="popupLogoutListItem"
        onClick={() => {
          logout(ESRoutes.Root);
        }}
        Icon={<IconLogout stroke={1.5} size={20} />}
      />
    </ESProfileSection>
  );
};
